import { render } from "./DeleteAgency.vue?vue&type=template&id=24061e10&scoped=true"
import script from "./DeleteAgency.vue?vue&type=script&lang=js"
export * from "./DeleteAgency.vue?vue&type=script&lang=js"

import "./DeleteAgency.vue?vue&type=style&index=0&id=24061e10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24061e10"]])

export default __exports__